import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ theme }) => ({
  color: theme.color.light,
  fontSize: theme.fontSize.small,
});

const ErrorCode = ({ children }) => {
  const { css } = useFela();

  return (
    <div className={css(rules)}>
      {children}
    </div>
  );
};

ErrorCode.propTypes = {
  children: PropTypes.node,
};

export default React.memo(ErrorCode);
